import Router from 'next/router';
import { IS_SERVER } from '@constants';

export const redirect = (path = '/', options = {}, code = 302, res) => {
  if (IS_SERVER) {
    if (!res) return;

    res.writeHead(code, { Location: path });
    res.end();
  } else {
    Router.push({ pathname: path }, path, options);
  }
};
